module.exports = __webpack_public_path__ + "static/media/中信建投app.6dd11f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/中信建投app.mp4
// module id = cQ3/
// module chunks = 3